exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-img[data-v-737d59b2]{width:100px;height:100px;cursor:pointer}", ""]);

// exports
